export default "__VITE_ASSET__BHx8nYsm__"